import { useEffect } from 'react';
import {
  useQuery,
  type UseQueryOptions,
} from '@tanstack/react-query';
import { toast } from '@/shared/hooks/use-toast';
import type { GalleryItem } from '../types';
import { presetApi } from '../api';
import { presetKeys } from './preset.keys';

export function usePresetGalleries(
  presetId?: string,
  options?: Omit<UseQueryOptions<GalleryItem[], Error>, 'queryKey' | 'queryFn'>
) {
  const queryKey = presetId ? presetKeys.galleries(presetId) : [...presetKeys.details(), 'galleries', ''];
  const query = useQuery({
    queryKey,
    queryFn: ({ signal }) => {
      if (!presetId) throw new Error('presetId não informado');
      return presetApi.getGalleries(presetId, signal);
    },
    enabled: Boolean(presetId),
    ...(options as Omit<UseQueryOptions<GalleryItem[], Error>, 'queryKey' | 'queryFn'>),
  });

  useEffect(() => {
    if (!query.error) return;
    toast({
      title: 'Erro ao carregar galeria do preset',
      description: query.error.message,
      variant: 'destructive',
    });
  }, [query.error]);

  return {
    galleries: query.data ?? [],
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    error: query.error,
    refetch: query.refetch,
    queryResult: query,
  };
}
